/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHuron = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M18.188 1.928a3.737 3.737 0 0 1 3.726 3.725v12.678a3.738 3.738 0 0 1-3.727 3.727h-2.7V17.26h1.683V5.83h-3.106v4.245H9.85V5.653a3.737 3.737 0 0 1 3.726-3.725z" />
        <path d="M7.94 1v4.83H6.818v11.43h3.02v-4.313h4.227v4.456a3.738 3.738 0 0 1-3.727 3.727H5.727A3.738 3.738 0 0 1 2 17.403V4.727A3.738 3.738 0 0 1 5.727 1z" />
      </g>
    </g>
  </Icon>
);
export { SvgHuron as Huron };
